import { useEffect, useRef, useState } from 'react';

export function useCountDown() {
  const [restTime, setRestTime] = useState(0);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (restTime <= 0) {
      if (timer.current) {
        clearInterval(timer.current);
        timer.current = undefined;
      }
      return;
    }

    timer.current = window.setInterval(() => {
      setRestTime((prev) => {
        if (prev <= 1) {
          if (timer.current) {
            clearInterval(timer.current);
            timer.current = undefined;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
        timer.current = undefined;
      }
    };
  }, [restTime]);

  return {
    restTime,
    setRestTime,
  };
}
